var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-rect-item",class:{ 'active' : _vm.active }},[_vm._t("main",null,{"props_slot":_vm.props_slot})],2)}
var staticRenderFns = []

export { render, staticRenderFns }